export default __webpack_public_path__ + "static/rsz_yaboo_white_background-e2e130d379871538cf92fa6d9e61840f.jpg";